import { render } from "./ChuKySo.vue?vue&type=template&id=512b7800"
import script from "./ChuKySo.vue?vue&type=script&lang=js"
export * from "./ChuKySo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__